// extracted by mini-css-extract-plugin
module.exports = {"container":"FieldsOfStudyPage_container__9rXHp","h1":"FieldsOfStudyPage_h1__1qbz7","subheading":"FieldsOfStudyPage_subheading__2AaSq","btn":"FieldsOfStudyPage_btn__cchcv"};